import { useState, useEffect, useRef } from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { FaArrowLeft, FaUpload } from "react-icons/fa";
import { HiArrowDownTray } from "react-icons/hi2";
import { FaTrash, FaPlus } from "react-icons/fa";
import { IoDocument, IoEye, IoCubeOutline } from "react-icons/io5";
import axios from 'axios';
import { toast } from "react-toastify";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { FaClock } from "react-icons/fa6";
import { FaRegClock, FaRegCheckCircle } from "react-icons/fa";
import { CiFilter } from "react-icons/ci";
import { FaXmark } from "react-icons/fa6";
import FileDetailPanel from '../comps/FileDetail.jsx';
import AnalysisProgressModal from '../comps/AnalysisProgressModal.jsx';
import AssemblyResultsBanner from '../comps/AssemblyResultsBanner.jsx';
import DeleteProgressModal from '../comps/DeleteProgressModal.jsx';
import ThumbnailImage from '../comps/ThumbnailImage.jsx';
import ProcessingStatus from '../comps/ProcessingStatus.jsx';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { uploadFileChunked, uploadMultipleFilesChunked, getTaskStatus } from '../services/uploadService.js';

export default function WorkspacePage() {
    const location = useLocation()
    const { folder_name, space_path, username } = location.state?.state || {};
    const [files, setFiles] = useState([]);
    const history = useHistory()
    const [labelFilter, setLabelFilter] = useState('')
    const [isExporting, setIsExporting] = useState(false)
    const [loading, setLoading] = useState(true);
    const [fetchError, setFetchError] = useState(null);
    const [folderData, setFolderData] = useState({});
    const [selectedFiles, setSelectedFiles] = useState(new Set());
    const [selectedPlay, setSelectedPlay] = useState('tariff_v1')
    const [isAssemblyMode, setIsAssemblyMode] = useState(false)
    const [topLevelPartId, setTopLevelPartId] = useState(null)  // User-selected top-level assembly file ID
    const [enabledPlays, setEnabledPlays] = useState(['tariff_v1', 'cost_reduction_v1']) // Default all enabled

    // Play display names mapping
    const PLAY_NAMES = {
        'tariff_v1': 'Tariff Analysis',
        'cost_reduction_v1': 'Cost Reduction',
        'veeco_design_review_v1': 'Design Review',
        'veeco_drawing_checker_v2': 'Drawing Checker V2',
        'veeco_drawing_checker_v1': 'Drawing Checker - Both',
        'veeco_drawing_checker_veeco_v1': 'Drawing Checker - Veeco',
        'veeco_drawing_checker_general_v1': 'Drawing Checker - General',
        'weight_v1': 'Weight Estimation'
    }
    const [isRunning, setIsRunning] = useState(false)
    const [analysisTaskId, setAnalysisTaskId] = useState(null)
    const [showAnalysisModal, setShowAnalysisModal] = useState(false)
    const [viewingFile, setViewingFile] = useState(null)
    const [viewingFileDefaultTab, setViewingFileDefaultTab] = useState(undefined)
    const [historyExpanded, setHistoryExpanded] = useState(true)
    // const [assemblyData, setAssemblyData] = useState(null)

    // Delete project state
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    
    // Delete individual file state
    const [showDeleteFileModal, setShowDeleteFileModal] = useState(false)
    const [fileToDelete, setFileToDelete] = useState(null)
    
    // Search state
    const [searchQuery, setSearchQuery] = useState('')
    const [showSearchDropdown, setShowSearchDropdown] = useState(false)
    const searchInputRef = useRef(null)

    // Upload state
    const [selectedUploadFiles, setSelectedUploadFiles] = useState([]) // Files selected but not yet uploaded
    const [uploadTaskId, setUploadTaskId] = useState(null) // Single task_id for all files (unified processing)
    const [uploadProgress, setUploadProgress] = useState(null) // Upload progress
    const [uploadStage, setUploadStage] = useState('idle') // idle | selecting | uploading | processing
    const [showUploadModal, setShowUploadModal] = useState(false)
    const fileInputRef = useRef(null)

    const BASE_URL = process.env.REACT_APP_BE_MAIN_URL;
    const GETFOLDER_API = `${BASE_URL}/ocr/getzipfiles/`;
    const RUN_ANALYSIS_API = `${BASE_URL}/ocr/analysis-run/`
    // const GET_ASSEMBLY_TARIFF_API = `${BASE_URL}/ocr/calculate-assembly-landed-cost/`
    const token = sessionStorage.getItem("userToken");

    // Component context state for V2 — keyed by file _id
    const [componentContexts, setComponentContexts] = useState({})

    const saveComponentContext = async (fileId, text) => {
        try {
            await axios.patch(
                `${BASE_URL}/ocr/file-context/${fileId}/`,
                { component_context: text },
                { headers: { Authorization: `Bearer ${token}` } }
            )
        } catch (err) {
            console.error('Failed to save component context', err)
            toast.error('Failed to save component context')
        }
    }

    const selectedFileObjects = files.filter(f => selectedFiles.has(f._id))
    const selectedFilenames = selectedFileObjects.map(
        f => f.base_metadata?.filename || f.filename
    )

    const getFilename = (file) =>
        file.base_metadata?.filename ||
        file.base_metadata?.original_filename ||
        file.filename ||
        file.original_filename

    // Handle individual file deletion
    const handleDeleteFile = async () => {
        if (!fileToDelete) return
        
        const token = sessionStorage.getItem("userToken")
        try {
            await axios.delete(
                `${BASE_URL}/ocr/delete-file/`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                    data: {
                        file_id: fileToDelete._id,
                        folder_name: folder_name,
                        space_path: space_path,
                        confirmation: 'DELETE'
                    }
                }
            )
            
            toast.success('File deleted successfully')
            setShowDeleteFileModal(false)
            setFileToDelete(null)
            
            // Remove from selected files if it was selected
            const newSelected = new Set(selectedFiles)
            newSelected.delete(fileToDelete._id)
            setSelectedFiles(newSelected)
            
            // Refresh the file list
            fetchFolderDetails()
        } catch (err) {
            console.error('Failed to delete file:', err)
            toast.error(err.response?.data?.error || 'Failed to delete file')
        }
    }

        

    // const runAnalysis = async () => {
    //     try {
    //         setIsRunning(true)
    //         const selectedFilenames = selectedFileObjects
    //             .map(getFilename)
    //             .filter(Boolean)

    //         if (!selectedFilenames.length) {
    //             alert("No valid filenames found")
    //             return
    //         }
    //         const payload = {
    //             play_id: selectedPlay,
    //             filenames: selectedFilenames,
    //             options: {
    //                 mode: analysisMode,
    //                 user_clarification: "",
    //                 force_refresh: false
    //             }
    //         }
    //         const res = await axios.post(RUN_ANALYSIS_API, payload, {
    //             headers: { Authorization: `Bearer ${token}` }
    //         })
    //         const status = res.data?.status || "analysing"
    //         setFiles(prev =>
    //             prev.map(file =>
    //                 selectedFilenames.includes(getFilename(file))
    //                     ? { ...file, status }
    //                     : file
    //             )
    //         )
    //         toast.success("Analysis started successfully")
    //     } catch (err) {
    //         console.error("Run analysis failed", err)
    //         toast.error(
    //         err.response?.data?.error || "Failed to start analysis"
    //     )
    //     } finally {
    //         setIsRunning(false)
    //     }
    // }
    const runAnalysis = async () => {
        try {
            setIsRunning(true)

            const selectedFilenames = selectedFileObjects
                .map(getFilename)
                .filter(Boolean)

            if (!selectedFilenames.length) {
                toast.warning("Please select at least one valid file to run analysis.")
                setIsRunning(false)
                return
            }

            const payload = {
                play_id: selectedPlay,
                filenames: selectedFilenames,
                folder_name: folder_name,  // Filter by project/folder
                options: {
                    mode: isAssemblyMode ? "assembly" : "individual",
                    user_clarification: "",
                    force_refresh: false,
                    top_level_file_id: isAssemblyMode ? topLevelPartId : null
                }
            }

            const res = await axios.post(RUN_ANALYSIS_API, payload, {
                headers: { Authorization: `Bearer ${token}` }
            })

            const taskStatus = res.data?.status || "analysing"
            const taskId = res.data?.task_id

            setFiles(prev =>
                prev.map(file =>
                    selectedFilenames.includes(getFilename(file))
                        ? { ...file, status: taskStatus }
                        : file
                )
            )

            // Show the analysis progress modal with task ID
            if (taskId) {
                setAnalysisTaskId(taskId)
                setShowAnalysisModal(true)
            }

        } catch (err) {
            console.error("Run analysis failed", err)
            toast.error("Failed to start analysis. Please try again.")
            setIsRunning(false)
        }
    }

    const handleAnalysisComplete = async (result) => {
        console.log('[WorkSpace] handleAnalysisComplete called with result:', result)
        setShowAnalysisModal(false)
        setAnalysisTaskId(null)
        setIsRunning(false)

        // Assembly navigation is now handled directly by the modal
        // For individual analysis (or cleanup after assembly navigation), refresh file list
        if (!result?.assembly_id) {
            console.log('[WorkSpace] Individual analysis complete, refreshing files')
            toast.success("Analysis complete!")
            const refreshedFiles = await fetchFolderDetails()

            // For Weight Estimation, open the result panel directly on the analyzed file
            if (result?.play_id === 'weight_v1' && Array.isArray(result?.results)) {
                const successfulResult = result.results.find(r => r?.success && r?.file_id)
                if (successfulResult) {
                    const targetFile = (refreshedFiles || []).find(f => f._id === successfulResult.file_id)
                    if (targetFile) {
                        setViewingFileDefaultTab('weight')
                        setViewingFile(targetFile)
                    }
                }
            }
        } else {
            // Assembly - just cleanup state, navigation already happened in modal
            console.log('[WorkSpace] Assembly cleanup complete')
            fetchFolderDetails()
        }
    }

    const handleAnalysisError = (errorMsg) => {
        toast.error(errorMsg || "Analysis failed")
        setIsRunning(false)
    }

    const handleAnalysisModalClose = () => {
        setShowAnalysisModal(false)
        setAnalysisTaskId(null)
        setIsRunning(false)
        // Refresh file list even on close
        fetchFolderDetails()
    }

    const handleAnalysisStop = () => {
        // User stopped the analysis - cached results are preserved
        setShowAnalysisModal(false)
        setAnalysisTaskId(null)
        setIsRunning(false)
        toast.info("Analysis stopped. Cached results are preserved and will be used on restart.")
        fetchFolderDetails()
    }

    // Handle file selection - show confirmation screen
    const handleFileSelect = (event) => {
        const selectedFiles = Array.from(event.target.files)
        if (selectedFiles.length === 0) return

        setSelectedUploadFiles(selectedFiles)
        setShowUploadModal(true)
        setUploadStage('selecting')
    }

    // Clear file selection
    const clearFileSelection = () => {
        setSelectedUploadFiles([])
        if (fileInputRef.current) {
            fileInputRef.current.value = ''
        }
    }

    // Handle actual upload after user confirms
    const handleUploadConfirm = async () => {
        if (selectedUploadFiles.length === 0) return

        setUploadStage('uploading')

        // Parse space_path to extract levels
        const levels = {}
        if (space_path) {
            const parts = space_path.split('/')
            parts.forEach((part, index) => {
                if (part) {
                    levels[`level${index + 1}`] = part
                }
            })
        }

        try {
            // Upload all files together and get ONE task_id with unified logs
            const result = await uploadMultipleFilesChunked({
                files: selectedUploadFiles,
                folderName: folder_name,
                levels,
                token,
                onProgress: (progress) => {
                    setUploadProgress(progress)
                }
            })

            if (result.task_id) {
                setUploadTaskId(result.task_id)
                setUploadStage('processing')
                setSelectedUploadFiles([])
            } else {
                throw new Error('No task_id received')
            }
        } catch (error) {
            console.error('Upload failed:', error)
            toast.error(error.message || 'Upload failed')
            setUploadStage('selecting')
        } finally {
            // Reset file input
            if (fileInputRef.current) {
                fileInputRef.current.value = ''
            }
        }
    }

    // Handle processing complete
    const handleProcessingComplete = () => {
        toast.success('Files processed successfully!')
        setShowUploadModal(false)
        setUploadTaskId(null)
        setUploadProgress(null)
        setUploadStage('idle')
        fetchFolderDetails()
    }

    // Handle processing error
    const handleProcessingError = (errorMsg) => {
        toast.error(errorMsg)
    }

    const fetchFolderDetails = async () => {
        try {
            setLoading(true);
            setFetchError(null);
            const res = await axios.get(GETFOLDER_API + `?username=${encodeURIComponent(sessionStorage.getItem("email"))}&space_path=${encodeURIComponent(space_path)}&folder_name=${encodeURIComponent(folder_name)}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setFolderData(res.data ?? {});
            const refreshedFiles = res.data.files || [];
            setFiles(refreshedFiles);
            // Seed component context state from existing file metadata
            const ctxMap = {};
            refreshedFiles.forEach(f => {
                if (f.base_metadata?.component_context) {
                    ctxMap[f._id] = f.base_metadata.component_context;
                }
            });
            setComponentContexts(prev => ({ ...prev, ...ctxMap }));
            return refreshedFiles;
        } catch (err) {
            console.error("Error fetching folder data:", err);
            setFetchError(err.response?.data?.error || err.message || "Failed to load files");
            toast.error("Failed to load project files");
            return [];
        } finally {
            setLoading(false);
        }
    };

    const fetchEnabledPlays = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/user/admin/org/plays/`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const enabled = res.data.enabled_plays || [];
            setEnabledPlays(enabled);
            // If current selected play is not enabled, switch to first enabled one
            if (enabled.length > 0 && !enabled.includes(selectedPlay)) {
                setSelectedPlay(enabled[0]);
            }
        } catch (err) {
            console.error("Error fetching enabled plays", err);
            // Keep defaults on error
        }
    };

    const exportToExcel = async () => {
        try {
            setIsExporting(true)

            // Create workbook with exceljs
            const workbook = new ExcelJS.Workbook()
            workbook.creator = 'SourceOptima'
            workbook.created = new Date()

            const worksheet = workbook.addWorksheet('Classification', {
                pageSetup: {
                    paperSize: 9, // A4
                    orientation: 'landscape',
                    fitToPage: true,
                    fitToWidth: 1,
                    fitToHeight: 0,
                    margins: {
                        left: 0.5, right: 0.5,
                        top: 0.75, bottom: 0.75,
                        header: 0.3, footer: 0.3
                    }
                }
            })

            // Corporate colors
            const primaryColor = 'FECF8B'  // Golden
            const headerBgColor = '1F2937' // Dark gray
            const headerTextColor = 'FFFFFF'
            const borderColor = 'D1D5DB'
            const altRowColor = 'FEF3C7' // Light amber

            // Check for play data availability
            // Tariff (HTS)
            const hasTariffData = filteredFiles.some(f => f.analyses?.tariff_v1?.data?.tradeCompliance?.primaryHts);

            // Define Base Columns
            const baseColumns = [
                { header: 'Filename', key: 'filename', width: 50 },
                { header: 'Label', key: 'label', width: 22 },
                { header: 'Confidence', key: 'confidence', width: 12 },
                { header: 'Description', key: 'description', width: 80 },
                { header: 'Material', key: 'material', width: 25 },
                { header: 'Material Gauge', key: 'gauge', width: 15 },
                { header: 'Organization Path', key: 'org_path', width: 40 },
                { header: 'Project', key: 'project', width: 25 }
            ];

            // Add Play-specific Columns
            if (hasTariffData) {
                baseColumns.push(
                    { header: 'Primary HTS Code', key: 'hts_primary', width: 20 },
                    { header: 'Primary HTS Code Confidence', key: 'hts_primary_conf', width: 25 },
                    { header: 'Primary HTS Code Description', key: 'hts_primary_desc', width: 60 },
                    { header: 'Alternative HTS Code', key: 'hts_alt', width: 20 },
                    { header: 'Alternative HTS Code Confidence', key: 'hts_alt_conf', width: 25 }
                );
            }

            const totalColumns = baseColumns.length;

            // Set column widths
            baseColumns.forEach((col, index) => {
                worksheet.getColumn(index + 1).width = col.width;
            });

            // Parse space_path into hierarchy levels
            const pathLevels = space_path ? space_path.split('/') : []

            // Title row
            const titleRow = worksheet.addRow([`Classification Report`])
            titleRow.height = 36
            titleRow.getCell(1).font = { bold: true, size: 20, color: { argb: '1F2937' } }
            worksheet.mergeCells(1, 1, 1, totalColumns)

            // Project info row
            const projectRow = worksheet.addRow([`Project: ${folder_name}`])
            projectRow.height = 22
            projectRow.getCell(1).font = { bold: true, size: 12, color: { argb: '374151' } }
            worksheet.mergeCells(2, 1, 2, totalColumns)

            // Organization path row
            const orgPathDisplay = pathLevels.length > 0 ? `Organization: ${pathLevels.join(' → ')}` : 'Organization: -'
            const orgRow = worksheet.addRow([orgPathDisplay])
            orgRow.height = 20
            orgRow.getCell(1).font = { size: 11, color: { argb: '6B7280' } }
            worksheet.mergeCells(3, 1, 3, totalColumns)

            // Export info row
            const exportDate = new Date().toLocaleDateString('en-US', {
                year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'
            })
            // Create array of empty strings matching total columns
            const infoRowVals = new Array(totalColumns).fill('');
            infoRowVals[0] = `Exported: ${exportDate}`;
            infoRowVals[totalColumns - 1] = `Total Files: ${filteredFiles.length}`;

            const infoRow = worksheet.addRow(infoRowVals)
            infoRow.height = 18
            infoRow.getCell(1).font = { size: 10, italic: true, color: { argb: '9CA3AF' } }
            infoRow.getCell(totalColumns).font = { size: 10, bold: true, color: { argb: '059669' } }
            infoRow.getCell(totalColumns).alignment = { horizontal: 'right' }

            // Empty row for spacing
            worksheet.addRow([])

            // Header row
            const headerValues = baseColumns.map(c => c.header);
            const headerRow = worksheet.addRow(headerValues)
            headerRow.height = 28
            headerRow.eachCell((cell, colNumber) => {
                cell.font = { bold: true, size: 11, color: { argb: headerTextColor } }
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: headerBgColor }
                }
                cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
                cell.border = {
                    top: { style: 'thin', color: { argb: borderColor } },
                    bottom: { style: 'medium', color: { argb: primaryColor } },
                    left: { style: 'thin', color: { argb: borderColor } },
                    right: { style: 'thin', color: { argb: borderColor } }
                }
            })

            // Data rows
            filteredFiles.forEach((file, index) => {
                const classification = file.base_metadata?.classification || {}
                
                // Build row values dynamically
                const rowValues = [
                    getFilename(file) || '',
                    classification.label || 'Unknown',
                    classification.confidence || '',
                    classification.description || '',
                    classification.primary_material || classification.material || '',
                    classification.material_gauge || '',
                    space_path || '',
                    folder_name || ''
                ];

                if (hasTariffData) {
                    const htsData = file.analyses?.tariff_v1?.data?.tradeCompliance?.primaryHts || {};
                    const altHtsList = file.analyses?.tariff_v1?.data?.tradeCompliance?.alternativeHts || [];
                    const altHtsData = altHtsList.length > 0 ? altHtsList[0] : {};
                    
                    rowValues.push(
                        htsData.code || '',
                        htsData.confidence ? `${htsData.confidence}%` : '',
                        htsData.description || htsData.rationale || '',
                        altHtsData.code || '',
                        altHtsData.confidence ? `${altHtsData.confidence}%` : ''
                    );
                }

                const row = worksheet.addRow(rowValues)

                row.height = 24
                const isAltRow = index % 2 === 1

                row.eachCell((cell, colNumber) => {
                    cell.font = { size: 10, color: { argb: '374151' } }
                    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true }
                    cell.border = {
                        top: { style: 'thin', color: { argb: borderColor } },
                        bottom: { style: 'thin', color: { argb: borderColor } },
                        left: { style: 'thin', color: { argb: borderColor } },
                        right: { style: 'thin', color: { argb: borderColor } }
                    }
                    if (isAltRow) {
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: altRowColor }
                        }
                    }
                })

                // Style the Label cell with color based on type
                const labelCell = row.getCell(2)
                labelCell.font = { size: 10, bold: true, color: { argb: '7C3AED' } }
            })

            // Add SourceOptima footer
            worksheet.addRow([]);
            const footerRow = worksheet.addRow(['Excel generated by SourceOptima']);
            footerRow.getCell(1).font = { size: 8, italic: true, color: { argb: 'FF808080' } };
            worksheet.mergeCells(footerRow.number, 1, footerRow.number, totalColumns);

            // Freeze header row
            worksheet.views = [
                { state: 'frozen', ySplit: 6, activeCell: 'A7' }
            ]

            // Auto-filter on data range
            worksheet.autoFilter = {
                from: { row: 6, column: 1 },
                to: { row: 6 + filteredFiles.length, column: totalColumns }
            }

            // Generate file
            const buffer = await workbook.xlsx.writeBuffer()
            const date = new Date().toISOString().split('T')[0]
            const filename = `${folder_name}_classification_${date}.xlsx`

            saveAs(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), filename)
            toast.success(`Exported ${filteredFiles.length} files to Excel`)
        } catch (err) {
            console.error('Export failed:', err)
            toast.error('Failed to export to Excel')
        } finally {
            setIsExporting(false)
        }
    }

    const toggleFileSelection = (fileId) => {
        const newSelected = new Set(selectedFiles)
        if (newSelected.has(fileId)) {
            newSelected.delete(fileId)
            // Clear top-level selection if the deselected file was the top-level
            if (topLevelPartId === fileId) {
                setTopLevelPartId(null)
            }
        } else {
            newSelected.add(fileId)
        }
        setSelectedFiles(newSelected)
    }

    // Handler for selecting a file as top-level assembly part
    const handleSetTopLevel = (fileId) => {
        if (selectedFiles.has(fileId)) {
            setTopLevelPartId(fileId)
        }
    }

    const uniqueLabels = files
        ? Array.from(
            new Set(files.map((f) => f.base_metadata.classification?.label || 'Unknown'))
        ).sort((a, b) => a.localeCompare(b))
        : []

    // Filter files by both label filter and search query
    const filteredFiles = files?.filter((file) => {
        // Label filter
        if (labelFilter) {
            const fileLabel = file.base_metadata.classification?.label || 'Unknown'
            if (fileLabel !== labelFilter) return false
        }
        
        // Search query filter
        if (searchQuery) {
            const filename = getFilename(file) || ''
            if (!filename.toLowerCase().includes(searchQuery.toLowerCase())) {
                return false
            }
        }
        
        return true
    })

    // Get matching filenames for autocomplete dropdown
    const matchingFilenames = searchQuery
        ? files
            ?.filter((file) => {
                const filename = getFilename(file) || ''
                return filename.toLowerCase().includes(searchQuery.toLowerCase())
            })
            .map((file) => getFilename(file))
            .filter(Boolean)
            .slice(0, 10) // Limit to 10 suggestions
        : []

    const toggleSelectAll = () => {
        if (!filteredFiles?.length) return

        const allSelected = filteredFiles.every(f =>
            selectedFiles.has(f._id)
        )

        if (allSelected) {
            // Deselect only filtered files
            const updated = new Set(selectedFiles)
            filteredFiles.forEach(f => updated.delete(f._id))
            setSelectedFiles(updated)
        } else {
            // Select all filtered files
            setSelectedFiles(
                new Set([
                    ...selectedFiles,
                    ...filteredFiles.map(f => f._id),
                ])
            )
        }
    }
    const handleThumbnailClick = (pdfUrl) => {
        window.open(pdfUrl, "_blank");
    };

    const extractMaterialFromDescription = (description) => {
        const match = description?.match(/material specifications\s*\(([^)]+)\)/i);
        return match ? match[1] : null;
    };

    

    useEffect(() => {
        fetchFolderDetails();
        fetchEnabledPlays();
    }, []);

    // Close search dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchInputRef.current && !searchInputRef.current.contains(event.target)) {
                setShowSearchDropdown(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => document.removeEventListener('mousedown', handleClickOutside)
    }, [])

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="bg-white border-b border-gray-200">
                <div className="px-6 py-4 flex items-center justify-between">
                    <button
                        onClick={() => history.push('/OrgChart')}
                        className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
                    >
                        <FaArrowLeft className="w-5 h-5" />
                        <span>Back to Projects</span>
                    </button>
                    <div className="text-center">
                        <h1 className="text-2xl font-bold text-gray-900">{folder_name}</h1>
                       
                    </div>
                    {/* Auto Filename Search */}
                    <div className="relative" ref={searchInputRef}>
                        <div className="flex items-center border rounded-lg px-2 py-1 gap-2">
                            <input
                                type="text"
                                placeholder="Search filename..."
                                value={searchQuery}
                                onChange={(e) => {
                                    setSearchQuery(e.target.value)
                                    setShowSearchDropdown(true)
                                }}
                                onFocus={() => searchQuery && setShowSearchDropdown(true)}
                                className="text-sm focus:outline-none w-48"
                            />

                            {searchQuery && (
                                <button
                                    onClick={() => {
                                        setSearchQuery('')
                                        setShowSearchDropdown(false)
                                    }}
                                    className="p-1 text-gray-400 hover:text-gray-600"
                                    title="Clear search"
                                >
                                    <FaXmark className="w-4 h-4" />
                                </button>
                            )}
                        </div>

                        {/* Autocomplete Dropdown */}
                        {showSearchDropdown && searchQuery && matchingFilenames.length > 0 && (
                            <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-64 overflow-y-auto z-50">
                                {matchingFilenames.map((filename, index) => (
                                    <button
                                        key={index}
                                        onClick={() => {
                                            setSearchQuery(filename)
                                            setShowSearchDropdown(false)
                                        }}
                                        className="w-full text-left px-3 py-2 text-sm hover:bg-green-50 border-b border-gray-100 last:border-b-0 transition-colors"
                                    >
                                        <span className="font-medium text-gray-900">
                                            {filename.substring(0, filename.toLowerCase().indexOf(searchQuery.toLowerCase()))}
                                            <span className="bg-yellow-200">
                                                {filename.substring(
                                                    filename.toLowerCase().indexOf(searchQuery.toLowerCase()),
                                                    filename.toLowerCase().indexOf(searchQuery.toLowerCase()) + searchQuery.length
                                                )}
                                            </span>
                                            {filename.substring(filename.toLowerCase().indexOf(searchQuery.toLowerCase()) + searchQuery.length)}
                                        </span>
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className="flex gap-2">
                        <input
                            ref={fileInputRef}
                            type="file"
                            multiple
                            accept=".pdf,.jpg,.jpeg,.png,.zip"
                            onChange={handleFileSelect}
                            className="hidden"
                        />
                        <button
                            onClick={() => fileInputRef.current?.click()}
                            disabled={uploadStage !== 'idle'}
                            className="bg-green-800 flex items-center gap-2 rounded-lg px-4 py-2 text-white font-medium hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                            title="Upload files to this folder"
                        >
                            <FaPlus />
                            New Upload
                        </button>
                        <button
                            onClick={() => setShowDeleteModal(true)}
                            className="px-4 py-2 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition-colors"
                            title="Delete project"
                        >
                            <FaTrash className="w-4 h-4" />
                        </button>
                    </div>
                </div>
            </div>
            <br />
            <div className="flex flex-wrap gap-4 bg-white mb-4 shadow-sm p-4 rounded-lg justify-between items-center">
                <button
                    onClick={toggleSelectAll}
                    className="text-sm text-green-600 hover:text-green-800 border-2 border-green-800 rounded-lg px-3 py-1"
                >
                    {filteredFiles?.every(f => selectedFiles.has(f._id))
                        ? 'Deselect All'
                        : 'Select All'}
                    {labelFilter ? ' (filtered)' : ''}
                </button>

                {/* Label Filter Dropdown */}
                <div className="flex items-center border rounded-lg px-2 py-1">
                    <CiFilter className="w-4 h-4 text-gray-500" />
                    <select
                        value={labelFilter}
                        onChange={(e) => setLabelFilter(e.target.value)}
                        className="text-sm focus:outline-none bg-white"
                    >
                        <option value="">All Labels</option>
                        {uniqueLabels.map((label) => {
                            const count = files?.filter(
                                (f) => (f.base_metadata.classification?.label || 'Unknown') === label
                            ).length
                            return (
                                <option key={label} value={label}>
                                    {label} ({count})
                                </option>
                            )
                        })}
                    </select>
                    {labelFilter && (
                        <button
                            onClick={() => setLabelFilter('')}
                            className="p-1 text-gray-400 hover:text-gray-600 rounded"
                            title="Clear filter"
                        >
                            <FaXmark className="w-4 h-4" />
                        </button>
                    )}
                </div>

                {/* Play Dropdown */}
                <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-600">Play:</span>
                    <select
                        value={selectedPlay}
                        onChange={(e) => {
                            const newPlay = e.target.value;
                            setSelectedPlay(newPlay);
                            // Disable assembly mode for Design Review and Drawing Checker plays
                            if (newPlay === 'veeco_design_review_v1' || newPlay.startsWith('veeco_drawing_checker_')) {
                                setIsAssemblyMode(false);
                            }
                        }}
                        disabled={enabledPlays.length === 0}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg
           focus:outline-none focus:ring-2 focus:ring-green-900
           focus:border-transparent transition-colors duration-200  text-sm
           disabled:bg-gray-100 disabled:cursor-not-allowed"
                    >
                        {enabledPlays.length === 0 ? (
                            <option value="">No plays available</option>
                        ) : (
                            Object.entries(PLAY_NAMES)
                                .filter(([id]) => enabledPlays.includes(id))
                                .map(([id, name]) => (
                                    <option key={id} value={id}>{name}</option>
                                ))
                        )}
                    </select>
                </div>

                {/* Assembly Mode Checkbox - disabled for Design Review and Drawing Checker */}
                <div className="flex flex-col gap-1">
                    <label className={`flex items-center gap-2 select-none ${(selectedPlay === 'veeco_design_review_v1' || selectedPlay === 'cost_reduction_v1' || selectedPlay.startsWith('veeco_drawing_checker_')) ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}>
                        <input
                            type="checkbox"
                            checked={isAssemblyMode}
                            onChange={(e) => {
                                setIsAssemblyMode(e.target.checked)
                                if (!e.target.checked) {
                                    setTopLevelPartId(null)  // Clear top-level when unchecking assembly mode
                                }
                            }}
                            disabled={selectedPlay === 'veeco_design_review_v1' || selectedPlay === 'cost_reduction_v1' || selectedPlay.startsWith('veeco_drawing_checker_')}
                            className="w-4 h-4 text-green-800 border-gray-300 rounded focus:ring-green-900 disabled:cursor-not-allowed"
                        />
                        <span className="text-sm text-gray-700">Treat as Assembly</span>
                    </label>
                    {/* Top Level Selection Instruction */}
                    {isAssemblyMode && selectedFiles.size > 0 && (
                        <div className={`text-xs ${topLevelPartId ? 'text-green-700' : 'text-orange-600'}`}>
                            {topLevelPartId
                                ? `Top level selected`
                                : 'Click "Set as Top Level" on a file card below'}
                        </div>
                    )}
                </div>
                {/* Action Buttons */}
                <div className="flex items-center gap-2">
                    <button
                        disabled={selectedFilenames.length === 0 || isRunning || enabledPlays.length === 0 || (isAssemblyMode && !topLevelPartId)}
                        onClick={runAnalysis}
                        className="px-3 py-2 text-sm font-medium bg-orange-500 text-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {isRunning ? 'Running...' : enabledPlays.length === 0
                            ? 'No plays available'
                            : isAssemblyMode && !topLevelPartId
                                ? 'Select Top Level Part First'
                                : `Run ${PLAY_NAMES[selectedPlay] || selectedPlay} on ${selectedFilenames.length} file(s)`}
                    </button>


                    {/* Export Excel Button */}
                    <button
                        disabled={isExporting || filteredFiles.length === 0}
                        onClick={exportToExcel}
                        className="flex items-center gap-1 px-3 py-2 bg-blue-700 text-white text-sm font-medium border-2 border-blue-700 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        <HiArrowDownTray className="w-4 h-4" />
                        {isExporting ? 'Exporting...' : 'Export Classification to Excel'}
                    </button>


                </div>
            </div>

            {/* {labelFilter && (
                <div className="text-sm text-gray-600">
                    Showing {filteredFiles?.length || 0} of {files?.length || 0} files
                    {labelFilter && (
                        <span className="ml-2">
                            filtered by: <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium `}>{labelFilter}</span>
                        </span>
                    )}
                </div>
            )} */}

            {/* Assembly Analyses Banner */}
            <div className="px-6 pt-4">
                <AssemblyResultsBanner folderName={folder_name} spacePath={space_path} />
            </div>

            <div className="p-6 bg-gray-50">
                <div className="bg-white rounded-xl">
                    {loading ? (
                        <div className="flex items-center justify-center py-12">
                            <div className="text-gray-500">Loading files...</div>
                        </div>
                    ) : fetchError ? (
                        <div className="flex flex-col items-center justify-center py-12 text-red-500">
                            <p className="text-lg font-medium">Error loading files</p>
                            <p className="text-sm mt-2">{fetchError}</p>
                            <button
                                onClick={fetchFolderDetails}
                                className="mt-4 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
                            >
                                Retry
                            </button>
                        </div>
                    ) : filteredFiles?.length === 0 ? (
                        <div className="flex flex-col items-center justify-center py-12 text-gray-500">
                            <p className="text-lg font-medium">No files found</p>
                            <p className="text-sm mt-2">
                                {files?.length === 0
                                    ? "This project has no files uploaded yet."
                                    : `No files match the current filter. (${files?.length} total files)`}
                            </p>
                        </div>
                    ) : null}
                    <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 ">
                        {filteredFiles?.map((file) => (
                            <div
                                key={file._id}
                                // className="border border-gray-200 rounded-xl bg-white hover:shadow-md transition"
                                className={` border card p-5 transition-all ${selectedFiles.has(file._id)
                                    ? 'ring-2 ring-green-900 bg-green-50'
                                    : 'hover:border-green-800'
                                    }`}

                            >
                                {/* Top Level Badge */}
                                {isAssemblyMode && topLevelPartId === file._id && (
                                    <div className="bg-yellow-400 text-yellow-900 text-xs font-bold px-2 py-1 text-center">
                                        TOP LEVEL ASSEMBLY
                                    </div>
                                )}
                                {/* File name + checkbox */}
                                <div className="flex items-start gap-3 p-3">
                                    <input
                                        type="checkbox"
                                        checked={selectedFiles.has(file._id)}
                                        onChange={() => toggleFileSelection(file._id)}
                                        className="mt-1 h-4 w-4"
                                    />

                                    <h3
                                        className="text-sm font-semibold text-gray-900 truncate"
                                        title={getFilename(file)}
                                    >
                                        {getFilename(file)}
                                    </h3>
                                </div>

                                <div className="px-3">
                                    <div className="h-44 w-full bg-gray-100 rounded-lg overflow-hidden border">
                                        {file.base_metadata?.s3_url ? (
                                            <ThumbnailImage
                                                fileId={file._id}
                                                filename={getFilename(file)}
                                                s3Url={file.base_metadata.s3_url}
                                                onThumbnailClick={handleThumbnailClick}
                                            />
                                        ) : (
                                            <div className="flex h-full items-center justify-center">
                                                <IoDocument className="w-10 h-10 text-gray-400" />
                                            </div>
                                        )}
                                    </div>
                                </div>


                                {/* Label + confidence + description */}
                                {/* <div className="p-3">
                                    <div className="flex items-center gap-2">
                                        <span
                                            className={`px-2 py-1 text-xs font-medium rounded ${file.base_metadata.classification?.label
                                                ? "bg-purple-100 text-purple-700"
                                                : "bg-gray-100 text-gray-500"
                                                }`}
                                        >
                                            {file.base_metadata.classification?.label || "Unknown"}
                                        </span>

                                        {file.base_metadata.classification?.confidence && (
                                            <span className="text-xs text-gray-500">
                                                ({file.base_metadata.classification.confidence})
                                            </span>
                                        )}
                                    </div>
                                 

                                    {file.base_metadata.classification?.material && (
                                        <div className="mt-2 text-xs text-blue-800 font-medium bg-blue-50 px-2 py-1 rounded inline-block">

                                            Material: {file.base_metadata.classification.material}
                                        </div>

                                    )}


                                    {file.base_metadata.classification?.description && (
                                        <p className="mt-2 text-sm text-gray-600 line-clamp-3">
                                            {file.base_metadata.classification.description}
                                        </p>
                                    )}
                                </div> */}

                                <div className="p-3">
                                    <div className="flex items-center gap-2">
                                        <span
                                            className={`px-2 py-1 text-xs font-medium rounded ${file.base_metadata.classification?.label
                                                ? "bg-purple-100 text-purple-700"
                                                : "bg-gray-100 text-gray-500"
                                                }`}
                                        >
                                            {file.base_metadata.classification?.label || "Unknown"}
                                        </span>

                                        {file.base_metadata.classification?.confidence && (
                                            <span className="text-xs text-gray-500">
                                                ({file.base_metadata.classification.confidence})
                                            </span>
                                        )}
                                    </div>
                                    {(file.base_metadata.classification?.primary_material ||
                                        file.base_metadata.classification?.material_gauge) && (
                                            <div className="mt-2 flex flex-wrap gap-2">
                                                {file.base_metadata.classification?.material_gauge && (
                                                    <span className="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded bg-purple-50 text-purple-700 border border-purple-200">
                                                        Gauge: {file.base_metadata.classification.material_gauge}
                                                    </span>
                                                )}
                                            </div>
                                        )}

                                    {/* Extracted Material */}
                                    {file.base_metadata.classification?.description && (() => {
                                        const material = extractMaterialFromDescription(
                                            file.base_metadata.classification.description
                                        );
                                        return material ? (
                                            <div className="mt-2 text-xs text-blue-800 font-medium bg-blue-50 px-2 py-1 rounded inline-block">
                                                Material: {material}
                                            </div>
                                        ) : null;
                                    })()}

                                    {/* Description */}
                                    {file.base_metadata.classification?.description && (
                                        <p className="mt-2 text-sm text-gray-600 line-clamp-3">
                                            {file.base_metadata.classification.description}
                                        </p>
                                    )}
                                </div>

                                {/* Component Context — V2/V3 drawing checker plays */}
                                {(selectedPlay === 'veeco_drawing_checker_v2') && (
                                    <div className="px-3 pb-2">
                                        <label className="block text-xs font-medium text-indigo-700 mb-1">
                                            Component Context <span className="text-gray-400 font-normal">(optional)</span>
                                        </label>
                                        <textarea
                                            rows={2}
                                            maxLength={1000}
                                            placeholder="What does this part do? e.g. 'Wafer chuck that holds 200mm substrates at 600°C in a CVD chamber'"
                                            value={componentContexts[file._id] || ''}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                setComponentContexts(prev => ({ ...prev, [file._id]: val }));
                                            }}
                                            onBlur={(e) => {
                                                const val = e.target.value.trim();
                                                saveComponentContext(file._id, val);
                                            }}
                                            className="w-full text-xs border border-indigo-200 rounded-md px-2 py-1.5 focus:outline-none focus:ring-1 focus:ring-indigo-400 focus:border-indigo-400 resize-none bg-white placeholder-gray-400"
                                        />
                                    </div>
                                )}

                                <div className="flex items-center gap-3 mt-3 pt-3 border-t border-gray-100">
                                    {/* Set as Top Level button - only visible in assembly mode for selected files */}
                                    {isAssemblyMode && selectedFiles.has(file._id) && topLevelPartId !== file._id && (
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                handleSetTopLevel(file._id)
                                            }}
                                            className="flex items-center gap-1.5 text-xs font-medium text-yellow-800 bg-yellow-100 hover:bg-yellow-200 px-2 py-1 rounded border border-yellow-300 transition-colors"
                                        >
                                            <IoCubeOutline className="w-4 h-4" />
                                            Set as Top Level
                                        </button>
                                    )}

                                    {/* Delete File Button */}
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            setFileToDelete(file)
                                            setShowDeleteFileModal(true)
                                        }}
                                        className="flex items-center gap-1.5 text-xs font-medium text-red-700 hover:text-red-900 hover:bg-red-50 px-2 py-1 rounded transition-colors"
                                        title="Delete this file"
                                    >
                                        <FaTrash className="w-3 h-3" />
                                    </button>

                                    {file.analyses && (file.analyses.tariff_v1 || file.analyses.cost_reduction_v1 || file.analyses.veeco_design_review_v1 || file.analyses.veeco_drawing_checker_v1 || file.analyses.veeco_drawing_checker_v2 || file.analyses.veeco_drawing_checker_veeco_v1 || file.analyses.veeco_drawing_checker_general_v1 || file.analyses.weight_v1) ? (
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                setViewingFile(file)
                                            }}
                                            className="ml-auto flex items-center gap-1.5 text-sm font-medium text-green-800 px-3 py-1.5 rounded-lg"
                                        >
                                            <IoEye className="w-5 h-5" />
                                            View Details
                                        </button>
                                    ) : (
                                        <span className="ml-auto text-sm text-gray-400 italic px-3 py-1.5">
                                            No analysis yet
                                        </span>
                                    )}


                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {viewingFile && (
                <FileDetailPanel
                    file={viewingFile}
                    selectedFiles={selectedFileObjects}
                    space_path={space_path}
                    folder_name={folder_name}
                    fileId={viewingFile._id}
                    filename={getFilename(viewingFile)}
                    thumbnail={viewingFile.thumbnail}
                    defaultTab={viewingFileDefaultTab}
                    onClose={() => {
                        setViewingFile(null)
                        setViewingFileDefaultTab(undefined)
                    }}
                />
            )}

            {/* Analysis Progress Modal */}
            {showAnalysisModal && analysisTaskId && (
                <AnalysisProgressModal
                    taskId={analysisTaskId}
                    playName={PLAY_NAMES[selectedPlay] || selectedPlay}
                    fileCount={selectedFilenames.length}
                    onComplete={handleAnalysisComplete}
                    onError={handleAnalysisError}
                    onClose={handleAnalysisModalClose}
                    onStop={handleAnalysisStop}
                    // Pass navigation props for assembly analyses
                    folderName={folder_name}
                    spacePath={space_path}
                    fileIds={selectedFileObjects.map(f => f._id)}
                />
            )}

            {/* Delete Project Modal */}
            {showDeleteModal && (
                <DeleteProgressModal
                    folderName={folder_name}
                    spacePath={space_path}
                    onComplete={() => {
                        setShowDeleteModal(false)
                        toast.success('Project deleted successfully')
                        history.push('/OrgChart')
                    }}
                    onClose={() => setShowDeleteModal(false)}
                />
            )}

            {/* Delete Individual File Modal */}
            {showDeleteFileModal && fileToDelete && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4">
                        <div className="flex items-start gap-3 mb-4">
                            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
                                <FaTrash className="w-5 h-5 text-red-600" />
                            </div>
                            <div className="flex-1">
                                <h3 className="text-lg font-semibold text-gray-900">Delete File</h3>
                                <p className="text-sm text-gray-600 mt-1">
                                    Are you sure you want to delete this file?
                                </p>
                                <p className="text-sm font-medium text-gray-900 mt-2 bg-gray-50 p-2 rounded">
                                    {getFilename(fileToDelete)}
                                </p>
                                <p className="text-xs text-red-600 mt-2">
                                    This action cannot be undone.
                                </p>
                            </div>
                        </div>
                        <div className="flex gap-3 justify-end">
                            <button
                                onClick={() => {
                                    setShowDeleteFileModal(false)
                                    setFileToDelete(null)
                                }}
                                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDeleteFile}
                                className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors"
                            >
                                Delete File
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Upload Modal */}
            {showUploadModal && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                    {uploadStage === 'selecting' ? (
                        // Stage 1: File Selection Screen
                        <div className="bg-white rounded-xl shadow-xl max-w-lg w-full">
                            <div className="flex items-center justify-between px-6 py-4 border-b">
                                <h2 className="text-xl font-semibold">Upload Files</h2>
                                <button onClick={() => {
                                    setShowUploadModal(false)
                                    setUploadStage('idle')
                                    clearFileSelection()
                                }}>
                                    <FaXmark />
                                </button>
                            </div>

                            <div className="p-6 space-y-5">
                                {/* Project Name */}
                                <div>
                                    <label className="block text-sm font-medium mb-1">
                                        Project Name
                                    </label>
                                    <input
                                        type="text"
                                        value={folder_name}
                                        disabled
                                        className="w-full border rounded-lg px-3 py-2 bg-gray-50"
                                    />
                                </div>

                                {/* File List Display */}
                                <div className="border-2 border-dashed border-green-600 bg-green-50 rounded-xl p-8 text-center">
                                    <FaUpload className="w-10 h-10 mx-auto text-gray-400 mb-3" />
                                    <p className="font-medium text-lg">
                                        {selectedUploadFiles.length} PDF file{selectedUploadFiles.length !== 1 ? 's' : ''} selected
                                    </p>
                                    <p className="text-sm text-gray-500 mt-1">
                                        {(selectedUploadFiles.reduce((sum, f) => sum + f.size, 0) / (1024 * 1024)).toFixed(2)} MB total
                                    </p>
                                    {selectedUploadFiles.length <= 5 && (
                                        <p className="text-xs text-gray-400 mt-2">
                                            {selectedUploadFiles.map(f => f.name).join(', ')}
                                        </p>
                                    )}
                                    <button
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            clearFileSelection()
                                            setShowUploadModal(false)
                                            setUploadStage('idle')
                                        }}
                                        className="mt-3 text-sm text-red-600 hover:text-red-800"
                                    >
                                        Clear selection
                                    </button>
                                </div>
                            </div>

                            {/* Footer */}
                            <div className="flex justify-end gap-3 px-6 py-4 border-t bg-gray-50">
                                <button
                                    onClick={() => {
                                        setShowUploadModal(false)
                                        setUploadStage('idle')
                                        clearFileSelection()
                                    }}
                                    className="border px-4 py-2 rounded-lg"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleUploadConfirm}
                                    className="bg-green-800 text-white px-4 py-2 rounded-lg hover:bg-green-700"
                                >
                                    Upload
                                </button>
                            </div>
                        </div>
                    ) : uploadStage === 'uploading' ? (
                        // Stage 2: Uploading Progress
                        <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full">
                            <div className="flex items-center justify-between px-6 py-4 border-b">
                                <h2 className="text-xl font-semibold">Uploading to {folder_name}</h2>
                            </div>
                            <div className="p-6">
                                <div className="text-center mb-4">
                                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-800 mx-auto mb-4"></div>
                                </div>
                                {uploadProgress && (
                                    <div className="space-y-2">
                                        <p className="text-sm text-gray-600 text-center">{uploadProgress.message}</p>
                                        {uploadProgress.totalFiles && (
                                            <p className="text-xs text-gray-500 text-center">
                                                File {uploadProgress.currentFile} of {uploadProgress.totalFiles}
                                            </p>
                                        )}
                                        {uploadProgress.percent !== undefined && (
                                            <div>
                                                <div className="flex justify-between text-xs mb-1">
                                                    <span>Progress</span>
                                                    <span>{uploadProgress.percent}%</span>
                                                </div>
                                                <div className="w-full bg-gray-200 rounded-full h-2">
                                                    <div
                                                        className="bg-green-600 h-2 rounded-full transition-all"
                                                        style={{ width: `${uploadProgress.percent}%` }}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : uploadStage === 'processing' ? (
                        // Stage 3: Processing with Unified Logs
                        <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-hidden">
                            <div className="flex items-center justify-between px-6 py-4 border-b">
                                <h2 className="text-xl font-semibold">Processing: {folder_name}</h2>
                            </div>
                            <div className="px-6 py-4">
                                {uploadTaskId ? (
                                    <ProcessingStatus
                                        taskId={uploadTaskId}
                                        onComplete={handleProcessingComplete}
                                        onError={handleProcessingError}
                                    />
                                ) : (
                                    <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                                        <p className="text-sm text-red-800">Upload failed - no task ID received</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : null}
                </div>
            )}

        </div>

    )
}
